var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("span", { staticClass: "h4" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "apeironGwApp.programaIntegradoCon.registro.seleccionePrograma"
                  )
                )
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.solicitud.programa
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm
                            .$t(
                              "apeironGwApp.programaIntegradoCon.mensajeSecciones"
                            )
                            .toString()
                        ),
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.programaIntegradoCon.registro.filtroPrograma"
                        ),
                        "label-for": "input-filtro-programa",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          name: "input-filtro-programa",
                          placeholder: _vm.$t("global.process.search.action"),
                        },
                        model: {
                          value: _vm.filtroPrograma,
                          callback: function ($$v) {
                            _vm.filtroPrograma = $$v
                          },
                          expression: "filtroPrograma",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.programaIntegradoCon.registro.filtroClave"
                        ),
                        "label-for": "input-filtro-clave",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          name: "input-filtro-clave",
                          placeholder: _vm.$t("global.process.search.action"),
                        },
                        model: {
                          value: _vm.filtroClave,
                          callback: function ($$v) {
                            _vm.filtroClave = $$v
                          },
                          expression: "filtroClave",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pt-4" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handlePageSizeChange()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.programaIntegradoCon.registro.buscar"
                            )
                          ),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.limpiarFiltros()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.programaIntegradoCon.registro.limpiar"
                            )
                          ),
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-overlay",
                {
                  attrs: { show: _vm.isFetching, "spinner-variant": "primary" },
                },
                [
                  _c("b-table", {
                    staticClass: "area-responsive",
                    staticStyle: { "max-height": "500px" },
                    attrs: {
                      "sticky-header": "500px",
                      "head-variant": "dark",
                      busy: _vm.isFetching,
                      items: _vm.programas,
                      fields: _vm.programasFields,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(clave)",
                        fn: function (data) {
                          return [
                            _c("span", {
                              domProps: { textContent: _vm._s(data.value) },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(nombre)",
                        fn: function (data) {
                          return [
                            _c("span", {
                              domProps: { textContent: _vm._s(data.value) },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(integrar)",
                        fn: function (row) {
                          return [
                            row.item.estePrograma
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "b-badge",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "info-circle" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "apeironGwApp.programaIntegradoCon.registro.estePrograma"
                                              )
                                            ),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !row.item.disponible
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "b-badge",
                                      { attrs: { variant: "info" } },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "plug-fill" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "apeironGwApp.programaIntegradoCon.registro.integrado"
                                              )
                                            ),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.esEscritura && !_vm.estaIntegrado
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      variant: "outline-success",
                                      size: "sm",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleIntegrarPrograma(
                                          row.item
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("entity.action.check")) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-form-select", {
                staticClass: "w-25",
                attrs: { size: "sm", options: _vm.perPageOptions },
                on: { change: _vm.handlePageSizeChange },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2" }, [
                _c("small", { staticClass: "font-weight-bold text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("global.table.perPage"))),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.perPage,
                  align: "center",
                  size: "sm",
                  pills: "",
                  disabled: _vm.isFetching,
                },
                on: { change: _vm.handlePageChange },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", [
            _c("span", [
              _c("small", { staticClass: "text-muted font-weight-bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("global.table.totalRows", {
                      totalRows: _vm.totalRows,
                    })
                  )
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  ref: "addIntegrado",
                  attrs: {
                    "no-close-on-esc": "",
                    "no-close-on-backdrop": "",
                    "hide-header-close": "",
                    size: "xl",
                    id: "addIntegrado",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.programaIntegradoCon.registro.registrarModalTitulo"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "outline-danger" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleCloseIntegrado()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("entity.action.cancel")
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "m-2",
                                      attrs: {
                                        disabled: _vm.formularioIsInvalid,
                                        variant: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.guardarProgramaIntegrado()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.programaIntegradoCon.registro.guardar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("strong", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.currentProgramaIngregado.clave
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("span"),
                        _vm._v(" "),
                        _c("strong", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.currentProgramaIngregado.nombre
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "apeironGwApp.programaIntegradoCon.form.fechaInicio"
                                  ) + " *",
                                "label-for": "input-sm",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  disabled: !_vm.esEscritura,
                                  placeholder: _vm.$t(
                                    "apeironGwApp.programaIntegradoCon.form.fechaInicio"
                                  ),
                                  required: "",
                                  locale: "es",
                                  state:
                                    !_vm.$v.currentProgramaIngregado.fechaInicio
                                      .$invalid,
                                },
                                model: {
                                  value:
                                    _vm.currentProgramaIngregado.fechaInicio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.currentProgramaIngregado,
                                      "fechaInicio",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "currentProgramaIngregado.fechaInicio",
                                },
                              }),
                              _vm._v(" "),
                              _vm.$v.currentProgramaIngregado.fechaInicio
                                .$invalid
                                ? _c("small", {
                                    staticClass: "text-danger",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.programaIntegradoCon.registro.indicarFechaInicial"
                                        )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.programaIntegradoCon.form.fechaFin"
                                ),
                                "label-for": "input-sm",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  disabled: !_vm.esEscritura,
                                  placeholder: _vm.$t(
                                    "apeironGwApp.programaIntegradoCon.form.fechaInicio"
                                  ),
                                  state:
                                    !_vm.$v.currentProgramaIngregado.fechaFin
                                      .$invalid,
                                  locale: "es",
                                },
                                model: {
                                  value: _vm.currentProgramaIngregado.fechaFin,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.currentProgramaIngregado,
                                      "fechaFin",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "currentProgramaIngregado.fechaFin",
                                },
                              }),
                              _vm._v(" "),
                              _vm.$v.currentProgramaIngregado.fechaFin.$invalid
                                ? _c("small", {
                                    staticClass: "text-danger",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.programaIntegradoCon.registro.formularioInvalido"
                                        )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }